export const projectsPagePath = '/user/projects';